import {
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { useModal } from '../../../../components/Utils/UseModal'
import ModalDocumento from '../../../comercial/proposta/ModalDocumento'
import { useCallback, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'
import { LuEye } from 'react-icons/lu'
import FileUploader from '../../../../components/FileUploader'
import PrimeTable from '../../../../components/PrimeTable'
import dayjs from 'dayjs'
import { FaFileSignature } from 'react-icons/fa'

export const Exames = ({ atendimentoSelecionado }) => {
  const openModal = useModal(ModalDocumento)
  const [dsDocumento, setDsDocumento] = useState('')
  const [refresh, setRefresh] = useState(true)
  const [novoDocumento, setNovoDocumento] = useState(false)

  const abrirArquivo = async (linhaOriginal) => {
    await openModal({
      nmDocumento: linhaOriginal?.[1],
      token: linhaOriginal?.[4],
    })
  }

  const salvaDocumento = async (v) => {
    const documento = v?.documento[0]

    const payload = {
      idDocumento: documento?.idDocumento,
      dsDocumento,
      idPaciente: atendimentoSelecionado?.dadosAtendimento?.[7]?.idPaciente,
    }

    await metodoPrograma('salvaDocumentoExamePaciente', payload)

    setDsDocumento('')
    setNovoDocumento(false)

    setRefresh((v) => !v)
  }

  const excluiDocumentoPaciente = useCallback((dados) => {
    metodoPrograma('deletaDocumentoExamePaciente', {
      idLaudo: dados[0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  return (
    <Grid item xs={12}>
      {!novoDocumento && (
        <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
          <Button
            variant="contained"
            onClick={() => setNovoDocumento(true)}
            startIcon={<FaFileSignature />}
          >
            Novo Documento
          </Button>
        </Grid>
      )}

      <Grid item xs={12}>
        {novoDocumento && (
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              mb: 3,
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary">
                  Informe um título que facilite a identificação do documento.
                  Sempre que possível, inclua o nome do exame e/ou a data em que
                  ele foi realizado.
                  <strong> Exemplo:</strong>{' '}
                  <i>Hemograma Completo - 15/07/2026</i> ou{' '}
                  <i>Ressonância Magnética - Coluna Lombar - 20/06/2026</i>.
                </Typography>
              </Grid>
              <Grid item xs={12} md={7}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="Título do documento"
                  placeholder="Ex.: Hemograma Completo - 15/07/2026"
                  value={dsDocumento}
                  onChange={(e) => setDsDocumento(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <FileUploader
                  key={novoDocumento}
                  disabled={!dsDocumento.trim()}
                  path="/proposta/"
                  fullWidth
                  snPublico="N"
                  onUploadComplete={salvaDocumento}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Button
                  color="inherit"
                  variant="outlined"
                  fullWidth
                  onClick={() => {
                    setNovoDocumento(false)
                    setDsDocumento('')
                  }}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )}
        {!novoDocumento && (
          <PrimeTable
            codigo="CtrlAtendimentoMedico"
            action="listaDocumentoExamePaciente"
            rows={10}
            parametros={{
              idPaciente:
                atendimentoSelecionado?.dadosAtendimento?.[7]?.idPaciente,
            }}
            head={['Título', 'Arquivo', 'Usuário', 'Data', 'Ações']}
            line={(item) => [
              item?.[7],
              item?.[1],
              item?.[3]?.[1],
              item?.[6] ? dayjs(item?.[6]).format('DD/MM/YYYY HH:mm') : '',
              '',
            ]}
            refresh={refresh}
            collumnsDateHour={[4]}
            onDelete={{ action: excluiDocumentoPaciente }}
            columnOptions={[
              {
                alias: 4,
                customJsx: ({ linhaOriginal }) => (
                  <IconButton
                    onClick={() => abrirArquivo(linhaOriginal)}
                    size="small"
                  >
                    <LuEye />
                  </IconButton>
                ),
              },
            ]}
          />
        )}
      </Grid>
    </Grid>
  )
}
